import Cookies from "js-cookie";

const TOKEN_KEY = "auth_token";

const isHttps = () =>
  typeof window !== "undefined" && window.location.protocol === "https:";

export const setTokenCookie = (token: string) => {
  Cookies.set(TOKEN_KEY, token, {
    expires: 1, // match your backend JWT lifetime
    path: "/",
    sameSite: "lax", //not set to 'strict', strict can drop the cookie when someone opens the panel
    //  from another link, which would look like a random logout
    secure: isHttps(), // Secure only when served over HTTPS
  });
};

export const getTokenCookie = () => {
  return Cookies.get(TOKEN_KEY);
};

export const removeTokenCookie = () => {
  Cookies.remove(TOKEN_KEY);
};
